 L.Control.Overview = L.Control.extend({
    options: {
        position: 'topleft',
    },
    _overview: null,
    initialize: function (overview) {
      L.Control.prototype.initialize.call(this.options)
      this._overview = overview
    },
   
 
    onAdd : function(map){
        
        var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-overview');
        var a = L.DomUtil.create('a')
        a.setAttribute('title', 'Overview result')
        div = L.DomUtil.create('div')
        a.append(div)
        div.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"/></svg>'
        container.appendChild(a)
        if (this._overview) {
           L.DomEvent.on(container, 'click',  this._overview)
        }
        return container
    },
   
})

module.exports = L.Control.Overview